<script setup lang="ts">
interface Props {
  variant?: 'outline' | 'filled' | 'bg' | 'alert'
  size?: 'sm' | 'md'
}
const props = withDefaults(defineProps<Props>(), {
  variant: 'outline',
  size: 'sm',
})

const sizeClasses = {
  sm: 'text-fluid-xs px-2 py-0.5 uppercase',
  md: 'text-fluid-sm px-4 py-2',
}
const variantClasses = {
  outline: 'border border-golden-amber text-golden-amber',
  filled: 'bg-golden-amber text-warm-asphalt',
  bg: 'border border-golden-amber text-golden-amber bg-[#423836A3] backdrop-blur',
  alert: 'bg-accent border-accent text-crosswalk',
}

const pillClasses = computed(() => [
  sizeClasses[props.size],
  variantClasses[props.variant],
])
</script>

<template>
  <div
    class="inline-flex justify-center items-center text-fluid-sm font-bold space-x-1 lg:space-x-2 rounded-full"
    :class="pillClasses"
  >
    <slot />
  </div>
</template>
